import { render } from "./ImportInstanceComponents.vue?vue&type=template&id=d54068c0"
import script from "./ImportInstanceComponents.vue?vue&type=script&lang=js"
export * from "./ImportInstanceComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__